<template>
  <form @submit.prevent="submitEditForm">
    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <FloatLabel variant="on">
            <InputText id="analise" v-model="dado.analise" size="small" style="width: 100%" disabled/>
            <label for="analise"><strong>Id Análise: </strong></label>
          </FloatLabel>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <FloatLabel variant="on">
            <InputText id="imovel" v-model="dado.imovel" size="small" style="width: 100%" disabled/>
            <label for="imovel"><strong>Imóvel: </strong></label>
          </FloatLabel>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <FloatLabel variant="on">
            <InputText id="cliente" v-model="dado.cliente" size="small" style="width: 100%" disabled/>
            <label for="cliente"><strong>Cliente: </strong></label>
          </FloatLabel>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <FloatLabel variant="on">
            <Select
                v-model="dado.fase"
                inputId="fase"
                :options="fase"
                optionLabel="label"
                optionValue="value"
                size="small"
                appendTo="body"
                style="width: 100%"
                @update:modelValue="atualizarOpcoesStatus(dado.fase)"
            />
            <label for="status"><strong>Fase: </strong></label>
          </FloatLabel>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <FloatLabel variant="on">
            <Select
                v-model="dado.status"
                inputId="status"
                :options="statusOptions"
                optionLabel="text"
                optionValue="value"
                size="small"
                appendTo="body"
                style="width: 100%"
            />
            <label for="status"><strong>Status: </strong></label>
          </FloatLabel>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <FloatLabel variant="on">
            <Textarea id="fase_observacao" v-model="dado.observacao" rows="2" cols="45"/>
            <label for="fase_observacao"><strong>Observação: </strong></label>
          </FloatLabel>
        </div>
      </div>
    </div>
    <hr>
    <div class="float-right">
      <button type="submit" class="btn btn-primary font-bold">Confirmar</button>
    </div>
    <button class="btn btn-danger font-bold" @click="$emit('fechar')">
      Cancelar
    </button>
  </form>
</template>

<script>
import BaseModal from '@/components/base/BaseModal.vue';
import {apiRequest} from "../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes";

export default {
  name: "AtualizarFase",
  components: {
    BaseModal,
  },
  props: {
    itemKey: String,
  },
  data() {
    return {
      dado: [],
      statusOptions: [],
      erro: null,
      fase: [
        {label: '1 - CREDITO', value: '1'},
        {label: '2 - IMÓVEL', value: '2'},
        {label: '3 - FINANCIAMENTO', value: '3'},
        {label: '4 - ENGENHARIA', value: '4'},
        {label: '5 - CONTRATO', value: '5'},
      ],
    }
  },
  emits: ['fechar', 'atualizaStatus'],
  methods: {
    atualizarOpcoesStatus(fase) {
      if (!fase) {
        fase = this.dado.fase;
      }

      switch (fase) {
        case '1':
        case '2':
          // Credito e Imóvel
          this.statusOptions = [
            {text: 'APROVADO', value: 'AP'},
            {text: 'EM ANÁLISE', value: 'E'},
            {text: 'REPROVADO', value: 'R'}
          ];
          break;
        case '3':
        case '4':
          // Financiamento e Engenharia
          this.statusOptions = [
            {text: 'APROVADO', value: 'AP'},
            {text: 'EM ANÁLISE', value: 'E'},
            {text: 'CONDICIONAMENTO', value: 'C'},
            {text: 'REPROVADO', value: 'R'}
          ];
          break;
        case '5':
          // Contrato
          this.statusOptions = [
            {text: 'EMITIDO', value: 'EM'},
            {text: 'ASSINADO', value: 'A'},
            {text: 'CANCELADO', value: 'CA'},
          ];
          break;
        default:
          this.statusOptions = [];
          break;
      }
    },
    async getDados() {
      const resultado = await apiRequest("GET", `${apiUrl.analises.faseCreateList}?chave=${this.itemKey}`);
      if (resultado.success) {
        this.dado = resultado.data[0];
        this.atualizarOpcoesStatus(this.dado.fase);
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async submitEditForm() {
      const resultado = await apiRequest("POST", apiUrl.analises.faseCreateList, this.dado);
      if (resultado.success) {
        this.$toastMessage("success", "Registro salvo com sucesso!");
        this.$emit('fechar');
        this.$emit('atualizaStatus', resultado.data)
      } else {
        if (resultado.error && typeof resultado.error === "object") {
          for (const campo in resultado.error) {
            resultado.error[campo].forEach(msg => {
              this.$toastMessage("error", campo, msg);
            });
          }
        } else {
          this.$toastMessage("warn", "Atenção", "Erro inesperado ao salvar!");
        }
        // if (resultado.error.fase) {
        //   this.$toastMessage("warn", "Atenção", resultado.error.fase);
        // } else {
        //   this.$toastMessage("warn", "Atenção", "Erro ao salvar registro!");
        // }
        // console.error("Erro ao salvar:", resultado.error);
      }
    },
  },
  mounted() {
    this.getDados();
  },
}
</script>
